import React from 'react';
import { Helmet } from 'react-helmet';
import './Contact.css';

const pageUrl = 'https://jerryevanoff.com/contact';
const pageTitle = 'Contact Jerry Evanoff | Mystery and Time Travel Fiction Author';
const pageDescription = 'Get in touch with author Jerry Evanoff, writer of the Sam Norris Murder Mystery Series and time travel science fiction.';

const Contact = () => {
  return (
    <div className="contact-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="author" content="Jerry Evanoff" />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:site_name" content="Jerry Evanoff" />
      </Helmet>

      <h2 className="contact-title">Contact Me</h2>
      <p className="contact-email">For inquiries, please contact me at:</p>
      <a href="mailto:jerry@jerryevanoff.com" className="contact-email-link">
        jerry@jerryevanoff.com
      </a>
    </div>
  );
};

export default Contact;
